import React from 'react';
import { Link } from 'react-router-dom';
import HallOfExcellence from '../components/HallOfExcellence';
import Pagination from '../components/Pagination';
import { TrophyIcon, XMarkIcon, ChevronLeftIcon, ChevronRightIcon, MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import AIChatButton from '../components/AIChatButton';

const Testimonials: React.FC = () => {
   ;
const testimonialImages = `https://drive.google.com/file/d/1cR1b0vJSGwlmPD7DxEqXGwfnX-nOCQ6G/view?usp=drive_link,
        https://drive.google.com/file/d/1RuuxWW5ZWaehcVxp0YJqg-AE9Kuk3jCI/view?usp=drive_link, 
        https://drive.google.com/file/d/1cmcm7mEedkvu0oMp5TOvxeq1cx289fWn/view?usp=drive_link, 
        https://drive.google.com/file/d/1dY0jgp_xWXQYnhkH0xBMy_RkwmDe3sLa/view?usp=drive_link, 
        https://drive.google.com/file/d/1dUv0_FnByXuOvbEFxnJu7GqymI5qRKhS/view?usp=drive_link, 
        https://drive.google.com/file/d/1cIzVF2TOErMOfd1Me_oDLhsPOjHkZDUy/view?usp=drive_link, 
        https://drive.google.com/file/d/1dNTwiyhgpjnIMkKf158ts4esfmF-R66-/view?usp=drive_link, 
        https://drive.google.com/file/d/1d5-jdJYi-R8-MvfkJi5-_31_OMSr_0_2/view?usp=drive_link, 
        https://drive.google.com/file/d/1cbmaoWU6uhONZh9GXvj3dE5XbbqsRO8A/view?usp=drive_link, 
        https://drive.google.com/file/d/1c8VH3JU6IxFxFOVe72CERT6S5ho7f1f0/view?usp=drive_link, 
        https://drive.google.com/file/d/1cB6Tepwlr_GzEbas3NheFn-aQ4gDeEAd/view?usp=drive_link, 
        https://drive.google.com/file/d/1xM2IDdZoGhA5T6JLFn9y2PsYG6T7198d/view?usp=drive_link 
        https://drive.google.com/file/d/1clB5HxzrAomJoWF4v-mwWAMy80_K2ODe/view?usp=drive_link 
        https://drive.google.com/file/d/1RvuVyFv-wO1uO9dB0A_phBQWXiGuA3qO/view?usp=drive_link, 
        https://drive.google.com/file/d/1Rw7FS-c4gNzVexr4_4VdTOvqUmGxEoPv/view?usp=drive_link, 
        https://drive.google.com/file/d/1RnUhmdKuhrH7BH_SS0n6E3T0qfrpcigZ/view?usp=drive_link, 
        https://drive.google.com/file/d/1S-V9cF6ad3xHgSujQ5WhIZXAm1l96FFT/view?usp=drive_link, 
        https://drive.google.com/file/d/1S1CjTBCVmcEWGx-YHneziPksTRCQZ5sU/view?usp=drive_link, 
        https://drive.google.com/file/d/1S2QWZR5TAHYFTvfZaZku9H0igovqGStY/view?usp=drive_link, 
        https://drive.google.com/file/d/1S2hLHNVBl54oYBP-e8al1zKLvKSVOn_v/view?usp=drive_link, 
        https://drive.google.com/file/d/1S3hoVLaZzseBmAuzmbAhFGs_qkypJ2C-/view?usp=drive_link, 
        https://drive.google.com/file/d/1S50sBrAKd5uRNmTFN91u0xPu4huETzMi/view?usp=drive_link, 
        https://drive.google.com/file/d/1S6fMvYtzQ8cq2B-_Gh3ZlS8fn20A8MKP/view?usp=drive_link, 
        https://drive.google.com/file/d/1SB4ZTN8-Jytv4WcgHPZGEe79ujODltTS/view?usp=drive_link, 
        https://drive.google.com/file/d/1SHyU6Ucyy6IrYMc1sw5LUivTf3KK4TIx/view?usp=drive_link, 
        https://drive.google.com/file/d/1SIDqPC5PIKk9RFKU2Pn50gmTxRkPZzfC/view?usp=drive_link, 
        https://drive.google.com/file/d/1SNG1e2qI-1uFqzq5R8shU15S1yfIzjYS/view?usp=drive_link, 
        https://drive.google.com/file/d/1STuz5yrPZLvzeDtMTBgyXWn6ifYPSqhZ/view?usp=drive_link, 
        https://drive.google.com/file/d/1SUUIY46psaajo16bhs-xdUuhNc0nk-hc/view?usp=drive_link, 
        https://drive.google.com/file/d/1SZj-HNh9-EC4MO_iN85mT-LFFSAcZffd/view?usp=drive_link, 
        https://drive.google.com/file/d/1S_DHu_q4A_wZgNOMzlDUQhr0a62xXRJ8/view?usp=drive_link,
        https://drive.google.com/file/d/1SfhGlFo7DGVtU7MZelJm4sDU9aZhV3te/view?usp=drive_link, 
        https://drive.google.com/file/d/1SiK1KLVJHc-eP5wqpjz58SAKEws1SJH4/view?usp=drive_link, 
        https://drive.google.com/file/d/1SnfMNtzEAPyKqU86w_HgRhTyzOp3fvUe/view?usp=drive_link, 
        https://drive.google.com/file/d/1SpmxpcLBDBvuMmDz2wAkekNgrH5O0ozn/view?usp=drive_link, 
        https://drive.google.com/file/d/1SwtvD58zIDoXWU9O0e-fqf62annAyZCF/view?usp=drive_link, 
        https://drive.google.com/file/d/1T5eVrAkkv9syC-1FnID-Ms1M7BiMZ2mF/view?usp=drive_link, 
        https://drive.google.com/file/d/1T8fl9I1mEjsDrY5P5a4X3AT_P2N1z6BX/view?usp=drive_link, 
        https://drive.google.com/file/d/1TEuZgYApnhLvO3DjJQp3e-wl0cL5x4u5/view?usp=drive_link, 
        https://drive.google.com/file/d/1TLvK-xu_SfYskanmTeWwBO0m9pvZ37dF/view?usp=drive_link, 
        https://drive.google.com/file/d/1TMd-Pgp2Lf9EBCXWo-2Yt6YPv9MwRP7V/view?usp=drive_link, 
        https://drive.google.com/file/d/1TNA-oVlTjBBbrHPWj-N_0Ss-So1rTuL5/view?usp=drive_link, 
        https://drive.google.com/file/d/1TSpTIM96hbmpYRMXLLnZ8K5U7pPhOSGB/view?usp=drive_link, 
        https://drive.google.com/file/d/1TT-lPASJsVFk2XC7bXpt9BBFvfxK64oJ/view?usp=drive_link, 
        https://drive.google.com/file/d/1TVuLgWUK-BS4IvO6aCZq5uZzyogNqul4/view?usp=drive_link, 
        https://drive.google.com/file/d/1T_IBPsdyt8xn3GVTCFRgVoS1W1pKPVYL/view?usp=drive_link, 
        https://drive.google.com/file/d/1Ta0Q6L-fqQtcDiMZ_GcMFuZgghxAsddN/view?usp=drive_link, 
        https://drive.google.com/file/d/1TbLcBRtXa9eW9e7UtTmE_59P0ZLzB0AA/view?usp=drive_link, 
        https://drive.google.com/file/d/1TkGdpKQc5H2zbN4Fba8ZoB-h_SqA6han/view?usp=drive_link, 
        https://drive.google.com/file/d/1sw68o8Rh_Y5-fAowKpOW41La5HsHcrrs/view?usp=drive_link, 
        https://drive.google.com/file/d/1sr-ivqmDM0t4j95GwD8JE_En3w_H16cr/view?usp=drive_link, 
        https://drive.google.com/file/d/1soSliEPLKKSX_C2k1FVc84hfRETG2K10/view?usp=drive_link, 
        https://drive.google.com/file/d/1sinXtHXr1xIDlZZM6c4Ht6BuDWIdeh9i/view?usp=drive_link, 
        https://drive.google.com/file/d/1sby-9tBe84D8Dpd8CFpoaevKi-C0TFky/view?usp=drive_link, 
        https://drive.google.com/file/d/1sacEsuE8VfMXxf63HlplwPyUAP7zhEtc/view?usp=drive_link, 
        https://drive.google.com/file/d/1sYufS0nhOTJYW_VCNSNBfHS3jvz6mU8I/view?usp=drive_link, 
        https://drive.google.com/file/d/1sXAwcvp5Ze5cGISOuqvm8Sl4JAEKRn9v/view?usp=drive_link, 
        https://drive.google.com/file/d/1sLzCmMtW3nSyO6dyto6htVqI-faCzSWP/view?usp=drive_link, 
        https://drive.google.com/file/d/1sKxXFoDpfurto3Xqk-Feq-B_3tRQPIby/view?usp=drive_link, 
        https://drive.google.com/file/d/1sKoiJwRxtlE87mU3ggKv8TEL7eDTI-Yw/view?usp=drive_link, 
        https://drive.google.com/file/d/1sGy9TAbAgGZ94HaMSD_LfxHOnJe1BzUG/view?usp=drive_link, 
        https://drive.google.com/file/d/1sGXK6jaMBKl_Xug4FpgNxMNVBpPUXekz/view?usp=drive_link, 
        https://drive.google.com/file/d/1sEuZbHSPj8uI0olv-PNd5IMPQE5XAkHd/view?usp=drive_link, 
        https://drive.google.com/file/d/1sBeCf2URDURAoFXHkUUy1moBf06CW6F3/view?usp=drive_link, 
        https://drive.google.com/file/d/1s9kfl6lRbJKAQxeY8GrY06B96yOqjEAk/view?usp=drive_link, 
        https://drive.google.com/file/d/1s9U5-4NLJ0Fwl0D2gNKeS7-8JCDM2-IN/view?usp=drive_link, 
        https://drive.google.com/file/d/1s5l1wTVynn2cFuuUJY6ecKhzJf3CRZIX/view?usp=drive_link, 
        https://drive.google.com/file/d/1rwk2mP9GI-D9etOT1nS8z-rOakWopvuc/view?usp=drive_link, 
        https://drive.google.com/file/d/1ruthA_YXgXrK5yjlZV3n92L7_u8Kciqh/view?usp=drive_link, 
        https://drive.google.com/file/d/1rlkiVwBpL7nh8JGLkQ47ecqwfDkKc407/view?usp=drive_link, 
        https://drive.google.com/file/d/1rkeKFN6eEs6iAgoYEyy26iv_akcbR-pE/view?usp=drive_link, 
        https://drive.google.com/file/d/1rgOtmoK5fKy_2Y9dThdqg6dWm6v8Pts8/view?usp=drive_link, 
        https://drive.google.com/file/d/1rW6FVcy0GEO-GqntCBTTB9M4QOtjekn-/view?usp=drive_link, 
        https://drive.google.com/file/d/1rS08-6YKlg-eYRSZT3CezX93xSXGcSUl/view?usp=drive_link, 
        https://drive.google.com/file/d/1rPocyptCtoO8WeNvdafXa5VHKSUjoKFu/view?usp=drive_link, 
        https://drive.google.com/file/d/1rJJxoFMTYTOA-wFT0uR3uacM4memjyzo/view?usp=drive_link, 
        https://drive.google.com/file/d/1rJ1b62zP3e8bX95Juq4ukLBLTU3ShN4V/view?usp=drive_link, 
        https://drive.google.com/file/d/1rIDU1SRe5GQQBCz88-LegEqpceRxZdJD/view?usp=drive_link, 
        https://drive.google.com/file/d/1dYMTBePbKBtzZCxhVx6cVMq1ZQ4fcFx_/view?usp=drive_link, 
        https://drive.google.com/file/d/1dVE4l-2fHiHsvWJAb_IMB5Bt3PJ6EcfX/view?usp=drive_link, 
        https://drive.google.com/file/d/1dNGQaNDcdL4_BwigMxpfQeyBVg5-NOfM/view?usp=drive_link, 
        https://drive.google.com/file/d/1dJr52DCNZuY5mT4I4DuoP6UDi3BJgAm6/view?usp=drive_link, 
        https://drive.google.com/file/d/1dHDTgAJbM5C3ImpKvFtWDXYgjYE5cCaD/view?usp=drive_link, 
        https://drive.google.com/file/d/1dFAkwwd0w_BEEk2AZIpkJbOFVt8CPeme/view?usp=drive_link, 
        https://drive.google.com/file/d/1dF9X-_sYQbLeazAxhMYK1zopYlMziKI3/view?usp=drive_link, 
        https://drive.google.com/file/d/1dCQmaxYcR6W2DMKUDYthWlXzDDPoTtFI/view?usp=drive_link, 
        https://drive.google.com/file/d/1dBhoCaaSs6t9AQ-hVNCKGme_wDOyRNtO/view?usp=drive_link, 
        https://drive.google.com/file/d/1d3K60y899g9YuksSvIYaw9OCNmgq8KJR/view?usp=drive_link, 
        https://drive.google.com/file/d/1d1tXWk-tGQV35bD62bSqYLSajauAKM_m/view?usp=drive_link, 
        https://drive.google.com/file/d/1d1ZG4vmRIj_ZYiUiEVookX9woKbEk877/view?usp=drive_link, 
        https://drive.google.com/file/d/1d-bv5_73IqHB_Qnj9x0R1nMrDLVv-5E0/view?usp=drive_link, 
        https://drive.google.com/file/d/1cv477ENPzqEUpLgScx0pskfnKyZR21Gj/view?usp=drive_link, 
        https://drive.google.com/file/d/1cjMUSXxdCraH0MGPw11m9yT9CcOC98S6/view?usp=drive_link, 
        https://drive.google.com/file/d/1cipRYBoY9LczxVMlKw87CBbF7DKQ_8eA/view?usp=drive_link, 
        https://drive.google.com/file/d/1cZ1zPzl0nzT67GBalKM6MndK3r38RTEz/view?usp=drive_link, 
        https://drive.google.com/file/d/1cSHPMpzTyOORrhzkEy58xEJ_-klCaDqY/view?usp=drive_link, 
        https://drive.google.com/file/d/1cRb8M_cywzppa877-jH7dUmqD8mvNYF5/view?usp=drive_link,
        
`
  
  const extractFileId = (driveLink: string): string | null => {
    const match = driveLink.match(/\/d\/(.*?)\//);
    return match ? match[1] : null;
  };

  const imageLinks = testimonialImages
    .split(/[\n,]+/)
    .map((link) => link.trim())
    .filter((link) => link.length > 0)
    .map(extractFileId)
    .filter((id): id is string => id !== null)
    .map((id) => `https://lh3.googleusercontent.com/d/${id}`);

  const [lightboxIndex, setLightboxIndex] = React.useState<number | null>(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 12;

  React.useEffect(() => {
    if (lightboxIndex === null) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightboxIndex(null);
      if (e.key === 'ArrowLeft') {
        setLightboxIndex((prev) => (prev === null ? prev : (prev + imageLinks.length - 1) % imageLinks.length));
      }
      if (e.key === 'ArrowRight') {
        setLightboxIndex((prev) => (prev === null ? prev : (prev + 1) % imageLinks.length));
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightboxIndex, imageLinks.length]);
    return (
    <div className="min-h-screen bg-white">

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-green-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-100 to-green-100 rounded-2xl mb-6">
            <TrophyIcon className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Student Success Stories
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Visual proof of our students' achievements and success stories
          </p>
        </div>
      </section>

      {/* Image Grid */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:columns-4 gap-6">
            {imageLinks
              .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
              .map((imageUrl, index) => {
                const actualIndex = (currentPage - 1) * itemsPerPage + index;
                return (
                  <div key={actualIndex} className="group cursor-zoom-in" onClick={() => setLightboxIndex(actualIndex)}>
                    <div className="relative overflow-hidden rounded-2xl shadow-lg border border-gray-200">
                      <img 
                        src={imageUrl} 
                        alt={`Student Success Story ${actualIndex + 1}`}
                        className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.style.display = 'none';
                          target.parentElement!.innerHTML = `
                            <div class=\"w-full h-64 bg-gradient-to-br from-blue-100 to-green-100 flex items-center justify-center\">
                              <div class=\"text-center\">
                                <div class=\"w-16 h-16 bg-gradient-to-br from-blue-200 to-green-200 rounded-full flex items-center justify-center mx-auto mb-3\">
                                  <span class=\"text-2xl\">📸</span>
                                </div>
                                <p class=\"text-gray-600 text-sm\">Image Loading...</p>
                              </div>
                            </div>
                          `;
                        }}
                      />
                      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-t from-black/60 via-black/20 to-transparent flex items-end justify-between p-3">
                        <div className="text-white text-sm font-medium">Preview</div>
                        <MagnifyingGlassPlusIcon className="w-6 h-6 text-white" />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          
          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(imageLinks.length / itemsPerPage)}
            onPageChange={setCurrentPage}
            itemsPerPage={itemsPerPage}
            totalItems={imageLinks.length}
          />
        </div>
      </section>

      {lightboxIndex !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
          <button
            aria-label="Close"
            className="absolute top-4 right-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition"
            onClick={() => setLightboxIndex(null)}
          >
            <XMarkIcon className="w-7 h-7" />
          </button>

          <button
            aria-label="Previous"
            className="absolute left-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition"
            onClick={() => setLightboxIndex((prev) => (prev === null ? prev : (prev + imageLinks.length - 1) % imageLinks.length))}
          >
            <ChevronLeftIcon className="w-8 h-8" />
          </button>

          <img
            src={imageLinks[lightboxIndex!]}
            alt={`Student Success Story ${lightboxIndex! + 1}`}
            className="max-h-[85vh] max-w-[90vw] rounded-xl shadow-2xl"
          />

          <button
            aria-label="Next"
            className="absolute right-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition"
            onClick={() => setLightboxIndex((prev) => (prev === null ? prev : (prev + 1) % imageLinks.length))}
          >
            <ChevronRightIcon className="w-8 h-8" />
          </button>

          <div className="absolute bottom-4 text-white/80 text-sm">
            {lightboxIndex! + 1} / {imageLinks.length}
          </div>
        </div>
      )}

      {/* Hall of Excellence */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <HallOfExcellence />
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-green-50">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Ready to Join These Success Stories?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Start your journey towards professional success today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/signup" className="btn-primary text-lg px-8 py-4 bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl">
              Start Your Journey
            </Link>
            <Link to="/catalog" className="btn-outline text-lg px-8 py-4 border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white transform hover:scale-105 transition-all duration-300">
              Browse Courses
            </Link>
          </div>
        </div>
      </section>

      {/* AI Chat Button */}
      <AIChatButton />
    </div>
  );
};

export default Testimonials;
